import React, { useRef, useContext } from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { lightAssets } from 'shared/screens/DailySpin/utils';
import ThemeContext from 'shared/context/ThemeContext';
import ImageBW from '../../../../components/ImageBoundsWrapper';
import {
  StreakColumnStyles,
  RegDaysRow,
  RegDaysLightImageLeft,
  RegDaysLightImageRight,
  RegDaysStreakDayText,
  RegDaysDayText,
  RegDayRowContentWrapper,
  RegDaysItemText,
  RegDaysItemWrapper,
  RegDaysItemCoinIcon,
  RegDaysItemWrapperCenter,
  RegDaysItemWrapperRight,
  RegDaysItemWrapperInnerText,
  RegDaysItemWrapperInnerIcon,
  EmptyDivSpace,
} from '../styledComponents';

export default function StreakDaysRow(props) {
  const themeContext = useContext(ThemeContext);
  const { item, index, day, bonusInfo, dailyWheelAssets } = props;
  const marker = useRef(null).current;
  const opacity = bonusInfo?.CURRENT_REWARD_DAY >= day + 1 ? 0.25 : 1;
  const light = lightAssets(dailyWheelAssets);

  return (
    <React.Fragment>
      <RegDaysRow>
        <RegDaysLightImageLeft src={light[bonusInfo?.CURRENT_REWARD_DAY >= day ? index + 1 : 0]} alt="" />
        <RegDaysLightImageRight src={light[bonusInfo?.CURRENT_REWARD_DAY >= day ? index + 1 : 0]} alt="" />
        {bonusInfo?.CURRENT_REWARD_DAY === day && (
          <>
            <ImageBW
              customRef={marker}
              source={dailyWheelAssets.DAILY_SPIN_STREAK_DAY_INDICATOR}
              ibw={require(asset`images/Daily_Spin/DailyBonus_DailyPrize_Indicator.ibw`)}
              style={StreakColumnStyles.streakDayRowIndicator}
              innerStyle={StreakColumnStyles.streakDayRowIndicatorInner}
            >
              <RegDaysStreakDayText theme={themeContext.DailySpin.StreakDaysRowNumber} length={String(day).length}>
                {day}
              </RegDaysStreakDayText>
            </ImageBW>
          </>
        )}
        {bonusInfo?.CURRENT_REWARD_DAY !== day && <RegDaysDayText opacity={opacity}>{day}</RegDaysDayText>}
        <RegDayRowContentWrapper>
          <RegDaysItemWrapper>
            <RegDaysItemWrapperInnerIcon>
              <RegDaysItemCoinIcon opacity={opacity} src={icons.coin} alt="coins" />
            </RegDaysItemWrapperInnerIcon>
            <RegDaysItemWrapperInnerText flex={2}>
              <RegDaysItemText
                theme={themeContext.DailySpin.StreakDaysRowValues}
                data-label={item.coins_trunc}
                opacity={opacity}
              >
                {item.coins_trunc}
              </RegDaysItemText>
            </RegDaysItemWrapperInnerText>
          </RegDaysItemWrapper>
          {item.loyalty_trunc ? (
            <>
              <RegDaysItemWrapperCenter opacity={opacity}>{getText(TEXT_KEY.PLUS_SYMBOL)}</RegDaysItemWrapperCenter>
              <RegDaysItemWrapperRight>
                <EmptyDivSpace flex={0.8} />
                <RegDaysItemWrapperInnerIcon paddingright={5}>
                  <ImageBW
                    source={icons.loyalty}
                    ibw={require(asset`Star_Icon.ibw`)}
                    resizeMode="contain"
                    style={{
                      ...StreakColumnStyles.regDaysItemLoyaltyIcon,
                      opacity: opacity,
                    }}
                  />
                </RegDaysItemWrapperInnerIcon>
                <RegDaysItemWrapperInnerText>
                  <RegDaysItemText
                    theme={themeContext.DailySpin.StreakDaysRowValues}
                    data-label={item.loyalty_trunc}
                    opacity={opacity}
                  >
                    {item.loyalty_trunc}
                  </RegDaysItemText>
                </RegDaysItemWrapperInnerText>
              </RegDaysItemWrapperRight>
            </>
          ) : (
            <EmptyDivSpace flex={1.3} />
          )}
        </RegDayRowContentWrapper>
      </RegDaysRow>
      {index < 8 && (
        <img src={dailyWheelAssets.DAILY_SPIN_STREAK_ROW_DIVIDER} alt="" style={StreakColumnStyles.rowDivider} />
      )}
    </React.Fragment>
  );
}

const icons = {
  coin: require(asset`images/Coin_Assets/Coin_Icon@3x.png`),
  loyalty: require(asset`Star_Icon@3x.png`),
};

